// Plantillas de hoja de cálculo (matrices rectangulares de celdas).
import { Wallet, Receipt, Tags, PiggyBank } from "lucide-react";

export const SHEET_TEMPLATES = [
  {
    id: "presupuesto-ieh",
    name: "Presupuesto (Ingresos/Egresos/Haber)",
    description: "Registra ingresos y egresos; el haber (saldo) se calcula solo.",
    icon: PiggyBank,
    cells: [
      ["Concepto", "Ingreso", "Egreso", "Haber"],
      ["Sueldo", "", "", "=B2-C2"],
      ["Alquiler", "", "", "=D2+B3-C3"],
      ["Alimentación", "", "", "=D3+B4-C4"],
      ["Transporte", "", "", "=D4+B5-C5"],
      ["Otros", "", "", "=D5+B6-C6"],
      ["Total", "=SUMA(B2:B6)", "=SUMA(C2:C6)", "=B7-C7"],
    ],
  },
  {
    id: "presupuesto",
    name: "Presupuesto mensual",
    description: "Compara lo presupuestado con el gasto real.",
    icon: Wallet,
    cells: [
      ["Categoría", "Presupuesto", "Real", "Diferencia"],
      ["Vivienda", "", "", "=B2-C2"],
      ["Comida", "", "", "=B3-C3"],
      ["Transporte", "", "", "=B4-C4"],
      ["Ocio", "", "", "=B5-C5"],
      ["Ahorro", "", "", "=B6-C6"],
      ["Total", "=SUMA(B2:B6)", "=SUMA(C2:C6)", "=B7-C7"],
    ],
  },
  {
    id: "gastos",
    name: "Control de gastos",
    description: "Registra tus gastos diarios y suma el total.",
    icon: Receipt,
    cells: [
      ["Fecha", "Concepto", "Categoría", "Monto"],
      ["", "", "", ""],
      ["", "", "", ""],
      ["", "", "", ""],
      ["", "", "", ""],
      ["", "", "", ""],
      ["Total", "", "", "=SUMA(D2:D7)"],
    ],
  },
  {
    id: "precios",
    name: "Lista de precios",
    description: "Calcula subtotales por cantidad automáticamente.",
    icon: Tags,
    cells: [
      ["Producto", "Precio unit.", "Cantidad", "Subtotal"],
      ["", "", "", "=B2*C2"],
      ["", "", "", "=B3*C3"],
      ["", "", "", "=B4*C4"],
      ["", "", "", "=B5*C5"],
      ["Total", "", "", "=SUMA(D2:D5)"],
    ],
  },
];
